export default __webpack_public_path__ + "static/Knjiga_popust-2da2864f5254c13d68eb391a249a619c.png";